module.exports = __webpack_public_path__ + "static/media/success.b2108743.png";